import { Link } from "react-router-dom";
import { Chip, Rows, Text } from "rothzerg-ui";

type YouMightAlsoLikeProps = {
  categories: { label: string; href: string }[];
};

export function YouMightAlsoLike({ categories }: YouMightAlsoLikeProps) {
  if (!categories.length) return null;

  return (
    <section id="you-might-also-like" className="kmart-section">
      <Text variant="h3" style={{ marginBottom: "1rem" }}>
        You might also like
      </Text>
      <Rows gap="sm">
        <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
          {categories.map((cat) => (
            <Link key={cat.label} to={cat.href}>
              <Chip label={cat.label} variant="outline" />
            </Link>
          ))}
        </div>
      </Rows>
    </section>
  );
}
